import './App.css';
import {
  Route,
  Routes,
  useLocation
} from 'react-router-dom'
import HelpCenter from './pages/helpCenter/HelpCenter';
import LoginHelpMain from './pages/loginHelp/LoginHelpMain';
import LoginHelpDetail from './pages/loginHelp/LoginHelpDetail';
import BindDeviceFaq from './pages/helpCenter/hotFaq/BindDeviceFaq';
import AccessoryFaq from './pages/helpCenter/hotFaq/AccessoryFaq';
import DeviceUnConnectFaq from './pages/helpCenter/hotFaq/DeviceUnConnectFaq';
import DeviceUseFaq from './pages/helpCenter/hotFaq/DeviceUseFaq';
import DeviceFixFaq from './pages/helpCenter/hotFaq/DeviceFixFaq';
import SaleServiceFaq from './pages/helpCenter/hotFaq/SaleServiceFaq';
import InstructionBook from './pages/helpCenter/Instruction/InstructionBook';
import Hardware from './pages/helpCenter/Instruction/Hardware';
import UseBook from './pages/helpCenter/Instruction/UseBook';
import FastIntro from './pages/helpCenter/Instruction/FastIntro';
import Accessory from './pages/helpCenter/accessory/Accessory';
import AccessoryUse from './pages/helpCenter/accessory/AccessoryUse';
import AccessoryInstall from './pages/helpCenter/accessory/AccessoryInstall';
import AddConnect from './pages/helpCenter/addAndConnect/AddConnect';
import ShareDevice from './pages/helpCenter/addAndConnect/ShareDevice';
import ConnectWifi from './pages/helpCenter/addAndConnect/ConnectWifi';
import SharePermission from './pages/helpCenter/addAndConnect/SharePermission';
import AddDevice from './pages/helpCenter/addAndConnect/AddDevice';
import ConnectFail from './pages/helpCenter/addAndConnect/ConnectFail';
import ShootUnConnect from './pages/helpCenter/shootFaq/ShootUnConnect';
import ShootUse from './pages/helpCenter/shootFaq/ShootUse';
import Gyroscope from './pages/helpCenter/shootFaq/Gyroscope';
import ChargeInUse from './pages/helpCenter/shootFaq/ChargeInUse';
import PreRecord from './pages/helpCenter/shootFaq/PreRecord';
import WideAngle from './pages/helpCenter/shootFaq/WideAngle';
import NoPush from './pages/helpCenter/monitorFaq/NoPush';
import VideoQuality from './pages/helpCenter/monitorFaq/VideoQuality';
import Offline from './pages/helpCenter/monitorFaq/Offline';
import MsgDelay from './pages/helpCenter/monitorFaq/MsgDelay';
import SdFormat from './pages/helpCenter/sdFaq/SdFormat';
import SdSpace from './pages/helpCenter/sdFaq/SdSpace';
import SdcardType from './pages/helpCenter/sdFaq/SdcardType';
import BatteryTime from './pages/helpCenter/batteryFaq/BatteryTime';
import HowToCharge from './pages/helpCenter/batteryFaq/HowToCharge';
import BatteryExtend from './pages/helpCenter/batteryFaq/BatteryExtend';
import BatteryNotice from './pages/helpCenter/batteryFaq/BatteryNotice';
import Captcha from './pages/captcha/Captcha';
import Invite from './pages/deviceShare/Invite';
import Lisence from './pages/privacy/Lisence';
import Privacy from './pages/privacy/Privacy';
import UseBookSingle from './pages/helpCenter/Instruction/UseBookSingle';
import ProductOperation from './pages/productOperation/ProductOperation';
import AppUpgrade from './pages/productOperation/AppUpgrade';

function App() {
  const location = useLocation()
  return (
    <div className='App'>
      <Routes location={location}>
        <Route exact path='/' element={<HelpCenter />} />
        <Route path="/help_center" element={<HelpCenter />} />
        <Route path="/login_help" element={<LoginHelpMain />} />
        <Route path="/login_help_detail" element={<LoginHelpDetail />} />
        <Route path="/bind_device_faq" element={<BindDeviceFaq />} />
        <Route path="/accessory_faq" element={<AccessoryFaq />} />
        <Route path="/device_unconnect_faq" element={<DeviceUnConnectFaq />} />
        <Route path="/device_use_faq" element={<DeviceUseFaq />} />
        <Route path="/device_fix_faq" element={<DeviceFixFaq />} />
        <Route path="/sale_service_faq" element={<SaleServiceFaq />} />
        <Route path="/instruction_book" element={<InstructionBook />} />
        <Route path="/hardware" element={<Hardware />} />
        <Route path="/use_book" element={<UseBook />} />
        <Route path="/use_book_single" element={<UseBookSingle />} />
        <Route path="/fast_intro" element={<FastIntro />} />
        <Route path="/accessory" element={<Accessory />} />
        <Route path="/accessory_use" element={<AccessoryUse />} />
        <Route path="/accessory_install" element={<AccessoryInstall />} />
        <Route path="/add_and_connect" element={<AddConnect />} />
        <Route path="/share_device" element={<ShareDevice />} />
        <Route path="/connect_wifi" element={<ConnectWifi />} />
        <Route path="/share_permission" element={<SharePermission />} />
        <Route path="/add_device" element={<AddDevice />} />
        <Route path="/connect_fail" element={<ConnectFail />} />
        <Route path="/shoot_un_connect" element={<ShootUnConnect />} />
        <Route path="/shoot_use" element={<ShootUse />} />
        <Route path="/gyroscope" element={<Gyroscope />} />
        <Route path="/charge_in_use" element={<ChargeInUse />} />
        <Route path="/pre_record" element={<PreRecord />} />
        <Route path="/wide_angle" element={<WideAngle />} />
        <Route path="/no_push" element={<NoPush />} />
        <Route path="/video_quality" element={<VideoQuality />} />
        <Route path="/offline" element={<Offline />} />
        <Route path="/msg_delay" element={<MsgDelay />} />
        <Route path="/sd_format" element={<SdFormat />} />
        <Route path="/sd_space" element={<SdSpace />} />
        <Route path="/sd_type" element={<SdcardType />} />
        <Route path="/battery_time" element={<BatteryTime />} />
        <Route path="/how_to_charge" element={<HowToCharge />} />
        <Route path="/battery_extend" element={<BatteryExtend />} />
        <Route path="/battery_notice" element={<BatteryNotice />} />
        <Route path="/captcha" element={<Captcha />} />
        <Route path="/invite" element={<Invite />} />
        <Route path="/lisence" element={<Lisence />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/product_operation" element={<ProductOperation />} />
        <Route path="/app_upgrade" element={<AppUpgrade />} />
      </Routes>
    </div>
  );
}

export default App;
